export const recoveryStrategyTypesSelector = state => state.recoveryStrategyReducer.recoveryStrategyTypes;

export const loadingRecoveryStrategyTypesSelector = state => state.recoveryStrategyReducer.loadingRecoveryStrategyTypes;

export const recoveryStrategySelector = state => state.recoveryStrategyReducer.recoveryStrategy;

export const loadingRecoveryStrategiesSelector = state => state.recoveryStrategyReducer.loadingRecoveryStrategies;
